// extracted by mini-css-extract-plugin
module.exports = {"deleteButtonContainer":"styles_deleteButtonContainer__zF5b6","confirmContainer":"styles_confirmContainer__FTyVx","deleteButton":"styles_deleteButton__IEOIf"};